import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import TranslatableEditor from "../../../../components/TranslatableEditor/TranslatableEditor";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import { useController } from "react-hook-form";

function InfoTextDialog(props) {
  const {
    field: { value: extra_settings_id },
  } = useController({ name: "extra_settings__id" });

  return (
    <Dialog
      disableEnforceFocus={true}
      onClose={() => {
        props.onClose();
      }}
      open={true}
    >
      <DialogTitle>
        <IconButton onClick={() => props.onClose()} style={{ position: "absolute", top: 20, right: 20 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <h3>
          <TranslationWrapper tDefault={"Infoscherm"} tKey={"vestigingen.form.berichten.headers.infoScreen"} />
        </h3>
        <TranslatableEditor
          contentName={"infoSplashContent"}
          endpointParams={{
            id: extra_settings_id,
            model_name: "extra_settings",
          }}
          textFields={[
            {
              name: "infoSplashTitle",
              label: {
                tKey: "infoSplash.translatableEditor.label.title",
                tDefault: "Title",
              },
            },
          ]}
        />
      </DialogContent>
    </Dialog>
  );
}

export default InfoTextDialog;
